import { useMutation, useQueryClient } from '@tanstack/react-query';

import { HttpClientError, IQuerySettings, QueryKeys, getQuerySettings } from '@dw/models/shared';
import { IInitializeAuthRequest, IInitializeAuthResponse, ISwitchSchoolsRequest } from '@dw/models/auth';
import { useAuth, useHttpClient, useSnackbar } from '@dw/hooks';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@dw/constants';

const BASE_URL = '/v1/auth';

export const useInitializeAuthMutation = (settings?: IQuerySettings<IInitializeAuthResponse, IInitializeAuthRequest>) => {
    const { POST } = useHttpClient();
    const queryClient = useQueryClient();

    const initializeAuth = async (request: IInitializeAuthRequest) => {
      return await POST<IInitializeAuthResponse>(`${BASE_URL}/initialize`, request);
    }

    const querySettings = getQuerySettings(settings)
    return useMutation<IInitializeAuthResponse, HttpClientError, IInitializeAuthRequest>({
      ...querySettings,
      mutationFn: initializeAuth,
      onSuccess: (response, input) => {
        queryClient.setQueryData([QueryKeys.Self], response.user);
        if (querySettings.onSuccess) {
          querySettings.onSuccess(response, input)
        }
      }
    })
}

export const useSwitchSchoolsMutation = (settings?: IQuerySettings<IInitializeAuthResponse, ISwitchSchoolsRequest>) => {
  const { POST } = useHttpClient();
  const queryClient = useQueryClient();
  const { setAuthDetails } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const switchSchools = async (request: ISwitchSchoolsRequest) => {
    return await POST<IInitializeAuthResponse>(`${BASE_URL}/switch-schools`, request);
  }

  const querySettings = getQuerySettings(settings)
  return useMutation<IInitializeAuthResponse, HttpClientError, ISwitchSchoolsRequest>({
    ...querySettings,
    mutationFn: switchSchools,
    onSuccess: (response, input) => {
      queryClient.clear();
      
      if (response.activeDanceSchoolUser) {
        queryClient.setQueryData([QueryKeys.DanceSchools, response.activeDanceSchoolUser.danceSchool.id], response.activeDanceSchoolUser.danceSchool);
        showSnackbar(`Successfully switched to ${response.activeDanceSchoolUser.danceSchool.name}`);
      }

      setAuthDetails(response);
      navigate(ROUTES.Dashboard);

      if (querySettings.onSuccess) {
        querySettings.onSuccess(response, input)
      }
    }
  })
}